import { render, staticRenderFns } from "./InstitucionalSliderTemas.vue?vue&type=template&id=40dc7c9c&"
import script from "./InstitucionalSliderTemas.vue?vue&type=script&lang=js&"
export * from "./InstitucionalSliderTemas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports